import { render, staticRenderFns } from "./ServiceInvoiceModal.vue?vue&type=template&id=45e2b5da&scoped=true"
import script from "./ServiceInvoiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceInvoiceModal.vue?vue&type=style&index=0&id=45e2b5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2b5da",
  null
  
)

export default component.exports